import { Component, OnInit } from '@angular/core';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TRENDING,RECOMMENDED,ILSHORTS,PUZZLES,TRENDING_VIDEOS_THIS_WEEK,RECOMMENDED_VIDEOS,INFINITY_SHORTS } from 'projects/selflearnv2-ui/src/app/constants/app.constants';
import { NgxSpinnerService } from 'ngx-spinner';



@Component({
  selector: 'app-self-learn-home',
  templateUrl: './self-learn-home.component.html',
  styleUrls: ['./self-learn-home.component.css']
})
export class SelfLearnHomeComponent implements OnInit {

  gradeSelected = 'option1';
  subjectNameList: any = [];
  subjectViewMoreStatus:boolean = false;
  widgetOrders:any = [];
  selfLearnHomepagePlaylsit:any = {
    trendingVideosPlaylist:[],
    recommendedVideosPlayList:[],
    shortsVideosPlayList:[],
    puzzleVideosPlayList:[],
  };
  playListIds:any = [];
  trendingVideosDisplayName = TRENDING_VIDEOS_THIS_WEEK;
  recommendedVideosDisplayName = RECOMMENDED_VIDEOS;
  ilShortsDisplayName = INFINITY_SHORTS;
  puzzlesDisplayName = PUZZLES;
  disableCourousal:boolean = false
  userInfo:any;
  uamExamId: any;
  uamGradeID: any;
  userId: any;
  cmsData: any;
  cmsExamId: any;
  examSelected:any;
  isUserFromLearn:any;
  userUamExams:any;
  resumeLearningData:any;
  resumelearningSubject: any;
  flashCardids:any=[];
  constructor(public selfLearnService: SelfLearnService,
    public router: Router, public spinner:NgxSpinnerService, private activatedRoute: ActivatedRoute,
    ) { }

  ngOnInit(): void {
    let _params = { ...(this.activatedRoute.snapshot.queryParams || {}) };
    const queryParams = { ..._params };
    if(!(Boolean(queryParams?.navigateToVideoPlayback) == true || Boolean(queryParams?.navigateToSelfLearnSubject) == true)){
      localStorage.removeItem('selctedBookId');
      localStorage.removeItem("selfLearnPreviousPage");
      localStorage.removeItem('selfLearnSelectedSubjectName');
      localStorage.removeItem("selfLearnSelectedSubject");
      localStorage.removeItem("chapterId");
      localStorage.removeItem("chapterName");
      localStorage.removeItem("selfLearnSelectedTopicId")
      localStorage.removeItem("selfLearnSelectedTopicName")
      localStorage.removeItem('selfLearnSelectedVideoId')
      localStorage.removeItem('selectedTopicName');
      localStorage.removeItem('isFromHomeScreen');
      localStorage.removeItem('previousScreen');
      localStorage.removeItem("selfLearnSelectedPlayName");
      localStorage.removeItem('memoryCardQuestionId');
      localStorage.removeItem("selfLearnSelectedVideoType");
    }
    this.getDefaultUserData();    
    // this.getAllHomeScreenPlaylistVideos();
  }
  getDefaultUserData(){
    this.userInfo = JSON.parse(sessionStorage.getItem('auth-user'));
    if(this.userInfo == null || this.userInfo == undefined ){
      this.userInfo = {
        "accessToken": localStorage.getItem('token'),
        "userDto": JSON.parse(localStorage.getItem('user_details_from_server'))
      }
    }
    localStorage.setItem('userInfo',JSON.stringify(this.userInfo));
    this.userUamExams = this.userInfo.userDto.exams;
    this.spinner.show();
    this.uamExamId = this.selfLearnService.isFromLearn() ? Number(this.selfLearnService.getUAMExamIdForLearn()) : this.userInfo.userDto.exams[0].examId;
    this.isUserFromLearn = this.selfLearnService.isFromLearn();
    this.examSelected =  localStorage.getItem('selfLearUamExamId')? Number(localStorage.getItem('selfLearUamExamId')): this.uamExamId;
    this.uamGradeID = this.userInfo.userDto.grade.gradeId;
    this.userId = this.userInfo.userDto.userId;
    this.getCmsData();
  }
  getCmsData(){

    this.selfLearnService.getCmsData(this.uamExamId,this.uamGradeID).subscribe((res:any)=> {
      if(res){
        this.cmsData = res;
        localStorage.setItem('cmsInfo',JSON.stringify(this.cmsData));
        this.cmsExamId = res.cmsExamId;
        if(this.cmsData.cmsGradeId == 6 || this.cmsData.cmsGradeId == 7){
          this.userUamExams = this.userUamExams.filter((item:any) => item.examId!=5);
        }
    
        // this.uamGradeID = res.cmsGradeId;
        //stat
        // let _params = { ...(this.activatedRoute.snapshot.queryParams || {}) };
        // const queryParams = { ..._params };
        // if(Boolean(queryParams?.navigateToVideoPlayback) == true){
        //   this.selfLearnService.getTopicScreenConfiguration().subscribe((res:any)=> {
        //     localStorage.setItem('topicScreenConfiguration',JSON.stringify(res))
        //     const navigationPath = "selfLearn-V2/videoplayback"
        //     this.router.navigateByUrl(navigationPath);
        //     return;
        //   });
        // }
        //end
        this.getSubjects();
        this.getWidgetOrder();
      }
     
    })
  }
  onExamSelect(event:any){
    this.uamExamId  = event.value;
    localStorage.setItem('selfLearUamExamId',this.uamExamId);
    console.log(this.uamExamId);
    this.getCmsData();
  }

  getSubjects(){
    // var userDetails = localStorage.getItem('user_details_from_server') ? JSON.parse(localStorage.getItem('user_details_from_server')) : {};
    // const usergrade = userDetails?.grade?.name?.replace(/[^0-9]/g, '');
    // const examName = localStorage.getItem('targetExamName') as string;
    let filterCMSData = this.cmsData;
    // let examInfo = (examName != 'CBSE') ? filterCMSData?.find((ele : any) => ele?.CMS_Exam_Name?.replaceAll(' ', '').toUpperCase() == examName && ele?.UAM_Grade_Name == (usergrade+'th'))
    //                                     : filterCMSData?.find((ele : any) => ele?.UAM_Exam_Name?.replaceAll(' ', '').toUpperCase() == examName && ele?.UAM_Grade_Name == (usergrade+'th'))
    let examId = this.cmsData.cmsExamId;
    this.selfLearnService.getSubjectsForExam(this.userId , examId).subscribe((resp) => {
      if (resp?.data?.childNodes != undefined) { 
        
        this.subjectNameList = resp?.data?.childNodes.filter((subject:any) => subject.isChaptersAvailable == true);
        this.getTopicScreenConfiguration();
        this.getBookMarkedFlashCards();
      }
      // if(usergrade == '13'){
      //   this.subjectNameList = this.subjectNameList?.filter((v:any) => {
      //     console.log(v.gradeIds);
      //     if (v.gradeIds != undefined) {
      //       return v.gradeIds.includes(11) ||  v.gradeIds.includes(12);
      //     }
      //     return false;
      //   });
      // } else {
      //   this.subjectNameList = this.subjectNameList?.filter((v:any) => v.gradeIds != undefined && v.gradeIds.includes(+usergrade));
      // }
      });
  }

  getAllHomeScreenPlaylistVideos(){
    this.selfLearnService.getAllHomeScreenPlaylistVideos(this.playListIds).then((resp) => {
      this.spinner.hide();
      const playlistData: any = resp;
      this.selfLearnHomepagePlaylsit.trendingVideosPlaylist = playlistData.trendingVideosPlaylist;
      this.selfLearnHomepagePlaylsit.recommendedVideosPlayList = playlistData.recommendedVideosPlayList;
      this.selfLearnHomepagePlaylsit.shortsVideosPlayList = playlistData.shortsVideosPlayList;
      this.selfLearnHomepagePlaylsit.puzzleVideosPlayList = playlistData.puzzleVideosPlayList;
      this.disableCourousal = true;
      this.assignOrder();
    });
  }

  subjectViewMoreButton(){
    this.subjectViewMoreStatus = !this.subjectViewMoreStatus;
  }

  async getWidgetOrder(){
    await this.selfLearnService.getWidgetOrders().subscribe((resp) => {
      const response:any = resp
      if(response.status){
        this.widgetOrders = response.data;
      } else{
        this.widgetOrders = [
          {
            "order": 1,
            "widgetName": "Subject",
            "screen": "Home",
            "layout": "SUBJECTSLAYOUT",
            "title": "Select a subject to start learning",
            "id": null
          },
          {
            "order": 2,
            "widgetName": "Trending",
            "screen": "Home",
            "layout": "VIDEOLAYOUT",
            "title": "Trending videos this week",
            "id": 4
          },
          {
            "order": 3,
            "widgetName": "Resume Learning",
            "screen": "Home",
            "layout": "RESUMELEARNINGLAYOUT",
            "title": "Resume Learning",
            "id": null
          },
          {
            "order": 6,
            "widgetName": "Recommended",
            "screen": "Home",
            "layout": "VIDEOLAYOUT",
            "title": "Recommended videos",
            "id": 6
          },
          {
            "order": 5,
            "widgetName": "ILShorts",
            "screen": "Home",
            "layout": "REELLAYOUT",
            "title": "Infinity Shorts",
            "id": 2
          },
          {
            "order": 4,
            "widgetName": "Puzzles",
            "screen": "Home",
            "layout": "VIDEOLAYOUT",
            "title": "Puzzles",
            "id": 5
          },
          {
            "order": 7,
            "widgetName": "One minute bite",
            "screen": "Home",
            "layout": "VIDEOLAYOUT",
            "title": "One minute bite",
            "id": 7
          }
        ]
      }    
    this.pushPlayListIds();
    });
  }

  pushPlayListIds() {
    this.widgetOrders.forEach((element:any) => {
      switch (element.widgetName) {
        case TRENDING:
          this.playListIds.push(element.id);
          break;
        case RECOMMENDED:
          this.playListIds.push(element.id);
          break;
        case ILSHORTS:
          this.playListIds.push(element.id);
          break;
        case PUZZLES:
          this.playListIds.push(element.id);
          break; 
        default:
          break;
      }
    })
    setTimeout(() => {
      this.getAllHomeScreenPlaylistVideos();
    }, 500);
  }

  assignOrder(){
    this.widgetOrders.forEach((element:any) => {
      let divId;
      switch (element.widgetName) {
        case TRENDING:
          divId = 'trendingDiv';
          break;
        case RECOMMENDED:
          divId = 'recommendedDiv';
          break;
        case ILSHORTS:
          divId = 'shotsDiv';
          break;
        case PUZZLES:
          divId = 'puzzleDiv';
          break; 
        default:
          break;
      }
      this.setOrder(divId,element);
    })
  }

  setOrder(divId:any, element){
    const htmlElement:any = document.getElementById(divId);
    if(htmlElement){htmlElement.style.order = element.order};
  }

  navigateToViewAllVideosList(videoType:any){
    let playListType = this.getplayListType(videoType);
    localStorage.setItem("selfLearnSelectedPlayName", videoType);
    localStorage.setItem("selfLearnSelectedVideoType", videoType);
    localStorage.setItem("selfLearnSelectedPlayList", playListType);
    this.router.navigateByUrl('selfLearn-V2/videos');
  }

  getplayListType(videoType:any){
    let playListType;
    switch (videoType) {
      case TRENDING:
        playListType = this.playListIds[0];
        break;
      case RECOMMENDED:
        playListType = this.playListIds[1];
        break;
      case ILSHORTS:
        playListType = this.playListIds[2];
        break;
      case PUZZLES:
        playListType = this.playListIds[3];
        break;
      default:
        break;
    }
    return playListType
  }

  navigateToSelectedSubject(subjectId:any, subjectName:any){
    localStorage.setItem('selfLearnSelectedSubject', subjectId);
    localStorage.setItem('selfLearnSelectedSubjectName', subjectName);
    this.router.navigateByUrl('selfLearn-V2/subject');
  }

  navigatetoVideoPlayback(videoData:any,videoType:any){
    const navigationPath = (videoType == ILSHORTS) ? "selfLearn-V2/shorts" : "selfLearn-V2/videoplayback"
    const playListType = this.getplayListType(videoType);
    localStorage.setItem("selfLearnSelectedPlayName", videoType);
    localStorage.setItem("selfLearnSelectedPlayList", playListType);
    localStorage.setItem("selfLearnPreviousPage", 'home');
    localStorage.setItem('selfLearnSelectedVideoId', videoData.videoId)
    this.router.navigateByUrl(navigationPath);
  }
  getResumeLearningForHomeScreen(){
    this.spinner.show();
    this.selfLearnService.getResumeLearningForHomeScreen().subscribe((resp:any) => {
      this.spinner.hide();
      if(resp && resp.status){
       this.resumeLearningData = resp;
      this.resumelearningSubject = this.subjectNameList.find((subject:any) => subject.nodeId == this.resumeLearningData.data.subjectId)
      }
    
    })
  }
  getBookMarkedFlashCards(){
    this.selfLearnService.getBookmarkedMemoryCards().subscribe((res:any) => {
      let data:any;
      data = res.data;
      data?.map((item:any) => {
        this.flashCardids.push(item.memoryCardId);
        
      })
   
    })
  }
  getTopicScreenConfiguration(){
    this.selfLearnService.getTopicScreenConfiguration().subscribe((res:any) => {
      localStorage.setItem('topicScreenConfiguration',JSON.stringify(res))
      let _params = { ...(this.activatedRoute.snapshot.queryParams || {}) };
        const queryParams = { ..._params };
        if(Boolean(queryParams?.navigateToVideoPlayback) == true){
          this.selfLearnService.getTopicScreenConfiguration().subscribe((res:any)=> {
            const navigationPath = "selfLearn-V2/videoplayback"
            this.router.navigateByUrl(navigationPath);
            return;
          });
        }else if(Boolean(queryParams?.navigateToSelfLearnSubject) == true){
          const navigationPath = "selfLearn-V2/subject"
          this.router.navigateByUrl(navigationPath);
          return;
        }
      this.getResumeLearningForHomeScreen();
    })
  }

}
